import React, { useEffect } from "react";
import { NotFoundBox } from "./PageNotFoundStyled";
import { Box, Link } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Congiguration } from "../../../Constants/AppConstants";
import image from "../../../images/pageNotFound.svg";
import { LocalStorageKeys, PageName } from "../../QuoteRequest/Content";
const PageNotFound = () => {
  const { state } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.setItem(LocalStorageKeys.CURRENTPAGE, PageName.ERRORPAGE);
  }, []);
  return (
    <NotFoundBox>
      <Box className="imageBox">
        <img src={image}></img>
      </Box>
      <Box className="contentBox">
       { state?.status===Congiguration.unauthorizedStatus ?
        <p>{Congiguration.pageNotFound404}</p>:
        <p>
          {Congiguration.pageNotFoundTextStart}
          <Link
            href={Congiguration.crmLink}
            target="_blank"
            rel="noopener"
            underline="hover"
          >
            {Congiguration.crmAppName}
          </Link>
        </p>}
      </Box>
    </NotFoundBox>
  );
};

export default PageNotFound;
